'use client';
import { useUserService } from './useUserService';

export const useUser = () => {
  const { useGetUserMe } = useUserService();
  const { data: user, isLoading } = useGetUserMe();
  // const isAuthenticated = Boolean(user);
  const isAuthenticated = false;

  return { isAuthenticated, user, isLoading };
};
